export const PURCHASE_REQUEST_HEADERS = ['supplier_id', 'product_barcode_id', 'no_of_units', 'expected_unit_price'];

export const getDispatchPurchaseRows = (order) => {
  const grouped = new Map();
  for (const item of order.items || []) {
    if (!['unavailable', 'insufficient'].includes(item.stock_status)) continue;
    const quantity = Number(item.shortage_units);
    if (!Number.isFinite(quantity) || quantity <= 0 || !item.product_barcode_id) continue;
    const key = String(item.product_barcode_id);
    const existing = grouped.get(key);
    if (existing) existing.no_of_units = Number((existing.no_of_units + quantity).toFixed(6));
    else grouped.set(key, {
      supplier_id: item.suggested_supplier_id || '',
      product_barcode_id: item.product_barcode_id,
      no_of_units: quantity,
      expected_unit_price: item.expected_purchase_unit_price ?? '',
    });
  }
  return [...grouped.values()];
};
